import appReducer from './app/reducer';
import storeReducer from './store/reducer';
import countriesReducer from './countries/reducer'

export default {
  app: appReducer,    
  store: storeReducer,  
  countries: countriesReducer  
};